import React from 'react';
import Wrp from '../../../hoc/Wrp/Wrp';

const emailField = (props) => {
	let value = props.value;
	let filterObject = props.filterObject;
	let classname = props.classname ? "form-control "+props.classname : "form-control";
	return (
		<Wrp>
		{
	        filterObject.input_value_type ? 
	   	 		<input type="email" className={classname} value={props.value} onChange={e=>props.filterOnChange(e, props.attr1, 'inputField', filterObject.has_multiple_input,props.attr4,props.attr6)} />

	    	: null
		}
		</Wrp>
	);
}

export default emailField;